// Sun/moon theme toggle (Session AFK): one control shared by the office header and the
// engineer PWA header. Icon-only (20px lucide, the brief's prescription; lucide-react was
// already a dependency via the engineer PWA), 44px tap target, tooltip via title. The icon
// shows the CURRENT mode (moon while dark) and the label names the switch destination.
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../lib/theme";

export function ThemeToggle() {
  const { toggle, isDark } = useTheme();
  const label = isDark ? "Switch to light mode" : "Switch to dark mode";
  const Icon = isDark ? Moon : Sun;
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className="flex h-11 w-11 flex-none items-center justify-center rounded-ele text-ele-muted outline-none transition hover:text-ele-strong focus-visible:ring-2 focus-visible:ring-ele-purple"
    >
      <Icon aria-hidden size={20} />
    </button>
  );
}
